import { appConfig as $config } from '../../app.config';
import { ValidationRules } from '../ValidationRules';
import { ColorVariants } from '../ColorVariants';
import { UI } from '../UI';
import { App } from '../App';

import './scss/sendapproval.scss';

export const SendApproval = (function () {
  let dialog = ({ data = {}, ok = () => {}, lastQuery = {} }) => {
    let template = require('./tmpl/dialog.hbs');
    bootbox
      .dialog({
        title: $Lang.prelistings.SendApproval,
        message: template({ prelisting: data, $lang: $lang }),
        size: 'lg',
        className: 'modal-scrolled-content',
        buttons: {
          Ok: {
            label: `<i class="fal fa-paper-plane fa-fw"></i> ${$lang.prelistings.SendApproval}`,
            className: 'btn btn-primary',
            callback: (e) => {
              send(e, ok, lastQuery);
              return false;
            }
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.close}`,
            className: 'btn btn-default'
          }
        }
      })
      .init(() => {
        dialoginit(data);
      });
  };

  let dialoginit = (prelisting) => {
    let dialog = $('#sendApprovalForm');
    dialog.validate({ rules: ValidationRules.sendApprovalDialog });

    let colorVar = $.extend(true, {}, prelisting);
    colorVar.variants.forEach((e) => {
      e.approved = true;
    });
    ColorVariants.init('#approval-colors', colorVar);
  };

  let send = (e, ok, lastQuery) => {
    let $form = $('#sendApprovalForm');

    if (!$form.valid()) {
      $('.form-control.is-invalid').focus();
      return false;
    }

    let formData = $form.serializeObject();

    UI.btn.spinnerRight(e.target);

    return;

    UI.block('#sendApprovalForm');
    $.when(App.ajaxData(`/LicensedProducts/sendSample`, formData, 'POST')) //Getting Brands list
      .done((res) => {
        if (!res.isSuccess) {
          return UI.errorMessage(res.errorInformation.errorReason);
        }
        bootbox.hideAll();
        UI.notify({
          text: $lang.alert.SuccessfullySend,
          icon: 'fal fa-check-circle',
          type: 'success'
        });
        ok(lastQuery.params, lastQuery.query);
      })
      .always((error) => {
        UI.unblock('#sendApprovalForm');
      });

    return false;
  };

  return {
    dialog
  };
})();
